if (!customElements.get('cv-mm-community-rail')) {
  customElements.define('cv-mm-community-rail', class extends HTMLElement {
    #controller;
    #observer;
    #scroll;
    #previous;
    #next;
    #controls;
    #frame;

    connectedCallback() {
      this.#scroll = this.querySelector('[data-cv-scroll]');
      this.#previous = this.querySelector('[data-cv-prev]');
      this.#next = this.querySelector('[data-cv-next]');
      this.#controls = this.querySelector('[data-cv-controls]');
      if (!this.#scroll || !this.#previous || !this.#next || !this.#controls) return;

      this.#controller?.abort();
      this.#observer?.disconnect();
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      this.#previous.addEventListener('click', () => this.#move(-1), { signal });
      this.#next.addEventListener('click', () => this.#move(1), { signal });
      this.#scroll.addEventListener('scroll', () => this.#scheduleUpdate(), { passive: true, signal });
      this.addEventListener('shopify:block:select', (event) => this.#selectBlock(event), { signal });
      this.#observer = new ResizeObserver(() => this.#scheduleUpdate());
      this.#observer.observe(this.#scroll);
      this.#update();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#observer?.disconnect();
      cancelAnimationFrame(this.#frame);
    }

    #scheduleUpdate() {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#update());
    }

    #update() {
      const maximum = this.#scroll.scrollWidth - this.#scroll.clientWidth;
      const position = Math.abs(this.#scroll.scrollLeft);
      this.#controls.hidden = maximum < 2;
      this.#previous.disabled = position < 2;
      this.#next.disabled = position >= maximum - 2;
    }

    /** @param {number} direction - Logical previous (-1) or next (1) item. */
    #move(direction) {
      const item = this.#scroll.querySelector('[data-cv-item]');
      const track = item?.parentElement;
      if (!item || !track) return;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      const sign = getComputedStyle(this.#scroll).direction === 'rtl' ? -1 : 1;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.#scroll.scrollBy({
        left: direction * sign * (item.getBoundingClientRect().width + gap),
        behavior: reducedMotion ? 'instant' : 'smooth'
      });
    }

    /** @param {Event} event - Theme editor block-selection event. */
    #selectBlock(event) {
      if (!(event.target instanceof Element)) return;
      const item = event.target.closest('[data-cv-item]');
      if (!item || !this.contains(item)) return;
      const viewport = this.#scroll.getBoundingClientRect();
      const itemBounds = item.getBoundingClientRect();
      const styles = getComputedStyle(this.#scroll);
      const padding = Number.parseFloat(styles.scrollPaddingInlineStart) || 0;
      const delta = styles.direction === 'rtl'
        ? itemBounds.right - viewport.right + padding
        : itemBounds.left - viewport.left - padding;
      this.#scroll.scrollBy({ left: delta, behavior: 'instant' });
    }
  });
}
